import React, { FunctionComponent } from 'react';
import { InternalLink } from '../../internal-link/internal-link';
import styles from './case-study-list-item.module.scss';
import { ICategoryModel } from '../../../models/category-model';
import { caseStudyArticleUrl } from '../../../utils/utils';

export interface ICaseStudyItem extends React.PropsWithChildren<{}> {
  language: string;
  id: string;
  title: string;
  slug: string;
  summary: string;
  image: {
    url: string;
    name: string;
  };
  categoryIndustry: ICategoryModel[];
  categoryProject: ICategoryModel[];
  categoryTechnology: ICategoryModel[];
  categoryCountry: ICategoryModel[];
}

export interface ICaseStudyListItemProps {
  data: ICaseStudyItem;
}

const CaseStudyListItemComponent: FunctionComponent<ICaseStudyListItemProps> = props => {
  const {
    data: {
      title,
      slug,
      summary,
      image: { url, name: alt },
      categoryIndustry,
      categoryProject,
      categoryTechnology,
      categoryCountry
    }
  } = props;

  const articleUrl = caseStudyArticleUrl(slug);

  const allCategories = [
    ...categoryIndustry,
    ...categoryProject,
    ...categoryTechnology,
    ...categoryCountry
  ];

  return (
    <article className={styles.container}>
      <InternalLink className={styles.articleWrapper} url={articleUrl}>
        <div className={styles.imageWrapper}>
          <img className={styles.articleImage} src={url} alt={alt} />
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.articleTitle}>{title}</h2>
          <p className={styles.articleDescription}>{summary}</p>
          <p className={styles.articleTags}>
            {allCategories.map((category: ICategoryModel, i: number) => (
              <span className={styles.tag} key={i}>
                {category.categoryName}
              </span>
            ))}
          </p>
        </div>
      </InternalLink>
    </article>
  );
};

export const CaseStudyListItem = React.memo(CaseStudyListItemComponent);
